import type { IconDef } from '../types';

export const heartFilled: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M22.8557 7.20893C22.4957 5.40893 21.4657 3.87893 20.0457 2.99893C18.5157 2.05893 16.5857 1.75893 14.8657 2.19893C13.7357 2.48893 12.7657 3.05893 11.9957 3.87893C11.2257 3.05893 10.2557 2.48893 9.12571 2.19893C7.41571 1.75893 5.47571 2.05893 3.95571 2.99893C2.52571 3.87893 1.50571 5.40893 1.14571 7.20893C0.815715 8.85893 0.885715 11.4689 3.09571 14.5689C5.58571 18.0489 8.84571 20.0289 10.5757 20.8989C11.0257 21.1289 11.5157 21.2389 12.0057 21.2389C12.4957 21.2389 12.9757 21.1289 13.4357 20.8989C15.1557 20.0289 18.4257 18.0489 20.9157 14.5689C23.1357 11.4789 23.1957 8.85893 22.8657 7.20893H22.8557Z',
    },
  ],
};
